import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getToken } from '../../store/selectors';
import './styles.scss';

const EmptyPage = () => {
    const { t } = useTranslation();
    const token = useSelector(getToken);

    return (
        <div className="empty-page-container">
            <img src={`static/images/empty.png`} alt="empty" />
            {token ? (
                <div className="empty-page-text">{t('dontHaveMission')}</div>
            ) : (
                <div className="empty-page-text">{t('logInToViewMissions')}</div>
            )}
        </div>
    );
};

export default EmptyPage;
